module.exports = __webpack_public_path__ + "static/img/step1.ba0ebe64.webp";